export enum ACCOUNT_PERMISSIONS {
  CREATE = 'can_create_accounts',
  EDIT = 'can_edit_accounts',
  DELETE = 'can_delete_accounts',
  VIEW_BTC = 'can_view_btc_accounts',
}

export enum CUSTOMER_PERMISSIONS {
  CREATE = 'can_create_clients',
  EDIT = 'can_edit_clients',
  DELETE = 'can_delete_clients',
  VIEW_BTC = 'can_view_btc_clients',
}

export enum MANAGER_PERMISSIONS {
  CREATE = 'can_create_managers',
  EDIT = 'can_edit_managers',
  DELETE = 'can_delete_managers',
}

export enum REPORT_PERMISSIONS {
  CREATE = 'can_create_reports',
  EDIT = 'can_edit_reports',
  DELETE = 'can_delete_reports',
}

export enum REASON_PERMISSIONS {
  CREATE = 'can_add_reasons',
  APPROVE = 'can_approve_reasons',
}
